import { Link } from "gatsby";
import * as React from "react";
import { Col, Row } from "react-bootstrap";
import {
  footerWrapper,
  copyRight,
  footerContent,
  logoCol,
  ctaCol,
  iconCol,
  brandLogos,
  contentCol,
} from "./Footer.module.scss";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

export const FooterWrapper: React.FC<any> = (props) => {
  return (
    <footer className={`${footerWrapper} pt-4 pb-3 pt-sm-5 pb-sm-5`}>
      {props.children}
    </footer>
  );
};

export const CopyRight: React.FC<any> = (props) => {
  return <p className={copyRight}>{props.children}</p>;
};
export const ContentRow: React.FC<any> = (props) => {
  return <Row className={footerContent}>{props.children}</Row>;
};
export const BrandLogoRow: React.FC<any> = (props) => {
  return <Row className={brandLogos}>{props.children}</Row>;
};
export const CopyrightRow: React.FC<any> = (props) => {
  return <div className="pt-0 pt-lg-2">{props.children}</div>;
};
export const LogoCol: React.FC<any> = (props) => {
  return <Col className={logoCol}>{props.children}</Col>;
};
export const IconCol: React.FC<any> = (props) => {
  return <Col className={iconCol}>{props.children}</Col>;
};
export const ContentCol: React.FC<any> = (props) => {
  return <Col className={contentCol}>{props.children}</Col>;
};
export const CopyrightCol: React.FC<any> = (props) => {
  return <div className="mb-2">{props.children}</div>;
};
export const CtaCol: React.FC<any> = (props) => {
  return <Col className={ctaCol}>{props.children}</Col>;
};
export const Logo: React.FC = () => {
  const { isMobileOnly } = useMobileDetectContext();
  return (
    <Link to="/" id="sonesta-footer-logo">
      {!isMobileOnly ? (
        <svg width="130" height="90">
          <use xlinkHref="/svg/sonesta-white.svg#SonestaLogo"> </use>
        </svg>
      ) : (
        <svg width="145" height="24" viewBox="0 0 145 24">
          <use xlinkHref="/svg/sonesta-logo-mobile.svg#SonestaLogoMobile">
            {" "}
          </use>
        </svg>
      )}
    </Link>
  );
};
